import { StockRestrictions } from '../../../../global/entities/BuyOrder';
import { RadioTrueFalseString } from '../../../../utils/radio/radio';

export const StockRestrictionLabel: Record<StockRestrictions, string> = {
  [StockRestrictions.None]: 'Nej, tack',
  [StockRestrictions.RightFirstOffer]: 'Förköp',
  [StockRestrictions.Consent]: 'Samtycke',
};

export const RightFirstRefusalLabel: Record<RadioTrueFalseString, string> = {
  true: 'Ja',
  false: 'Nej',
};
